import { compose } from 'redux';
import { createEditor } from 'slate';
import { ReactEditor } from 'slate-react';

import plugins from 'craft/rte/plugins';

export default () => compose(...plugins)(createEditor()) as ReactEditor;
